// @ts-nocheck
import type { Question } from '../types';

export const incidentFirstAidQuestions: Question[] = [
  {
    id: 'q-ifa-1',
    topic: 'General',
    question: 'You are first at the scene of a road accident. What is the first thing you should do?',
    options: [
      { id: 'q-ifa-1o1', text: 'Move the injured to the side of the road' },
      { id: 'q-ifa-1o2', text: 'Make sure the scene is safe (switch off engines, warn traffic) and call emergency services' },
      { id: 'q-ifa-1o3', text: 'Leave immediately to get help' }
    ],
    answerId: 'q-ifa-1o2',
    explanation: 'First make the scene safe (e.g. switch off ignitions, warn other traffic). Then call emergency services and give first aid if trained.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-2',
    topic: 'General',
    question: 'What should you do if someone is unconscious and not breathing normally at an accident?',
    options: [
      { id: 'q-ifa-2o1', text: 'Leave them and wait for ambulance' },
      { id: 'q-ifa-2o2', text: 'Call emergency services and start CPR if you are trained' },
      { id: 'q-ifa-2o3', text: 'Give them water' }
    ],
    answerId: 'q-ifa-2o2',
    explanation: 'Call emergency services immediately. If they are not breathing normally and you are trained, start CPR. If an AED is available, use it.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-3',
    topic: 'General',
    question: 'You are involved in an accident. What information should you exchange with the other driver?',
    options: [
      { id: 'q-ifa-3o1', text: 'Only names' },
      { id: 'q-ifa-3o2', text: 'Names, addresses, vehicle registration, and insurance details' },
      { id: 'q-ifa-3o3', text: 'Only phone numbers' }
    ],
    answerId: 'q-ifa-3o2',
    explanation: 'Exchange names, addresses, vehicle registration numbers, and insurance details. Report the accident to the police if required.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-4',
    topic: 'General',
    question: 'When should you use a warning triangle at an accident?',
    options: [
      { id: 'q-ifa-4o1', text: 'Only on motorways' },
      { id: 'q-ifa-4o2', text: 'To warn other traffic; place it at a safe distance on the same side of the road' },
      { id: 'q-ifa-4o3', text: 'Only at night' }
    ],
    answerId: 'q-ifa-4o2',
    explanation: 'Place a warning triangle well behind the vehicle to warn approaching traffic. Use hazard lights. On motorways, stay behind the barrier if possible.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-5',
    topic: 'General',
    question: 'What should you do if someone is bleeding heavily from a wound?',
    options: [
      { id: 'q-ifa-5o1', text: 'Leave it; do not touch' },
      { id: 'q-ifa-5o2', text: 'Apply direct pressure with a clean cloth or dressing; call for help' },
      { id: 'q-ifa-5o3', text: 'Pour water on it' }
    ],
    answerId: 'q-ifa-5o2',
    explanation: 'Apply direct pressure to the wound with a clean cloth or dressing to control bleeding. Call for emergency help.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-6',
    topic: 'General',
    question: 'You break down on the motorway. What should you do?',
    options: [
      { id: 'q-ifa-6o1', text: 'Stay in the car and wait' },
      { id: 'q-ifa-6o2', text: 'Move to a safe place (e.g. behind barrier), use hazard lights, and call for help' },
      { id: 'q-ifa-6o3', text: 'Walk to the next exit' }
    ],
    answerId: 'q-ifa-6o2',
    explanation: 'Get everyone to a safe place (e.g. behind the barrier). Use hazard lights. Call for help. Do not stay in the car on the carriageway.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-7',
    topic: 'General',
    question: 'What should you do if you suspect someone has a spinal injury?',
    options: [
      { id: 'q-ifa-7o1', text: 'Move them to a comfortable position' },
      { id: 'q-ifa-7o2', text: 'Keep them still; support the head and neck; call emergency services' },
      { id: 'q-ifa-7o3', text: 'Sit them up' }
    ],
    answerId: 'q-ifa-7o2',
    explanation: 'Do not move them unless in immediate danger. Support the head and neck to keep the spine in line. Call emergency services.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-8',
    topic: 'General',
    question: 'When must you report an accident to the police?',
    options: [
      { id: 'q-ifa-8o1', text: 'Only if someone is injured' },
      { id: 'q-ifa-8o2', text: 'When someone is injured, or when there is significant damage or other reportable circumstances (rules vary by country)' },
      { id: 'q-ifa-8o3', text: 'Never; insurance handles it' }
    ],
    answerId: 'q-ifa-8o2',
    explanation: 'You must report an accident to the police when someone is injured, or when required by law (e.g. hit-and-run, significant damage).',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-9',
    topic: 'General',
    question: 'What is the "primary survey" in first aid?',
    options: [
      { id: 'q-ifa-9o1', text: 'Checking the car for damage' },
      { id: 'q-ifa-9o2', text: 'Checking Danger, Response, Airway, Breathing, Circulation (DRABC)' },
      { id: 'q-ifa-9o3', text: 'Taking photos of the scene' }
    ],
    answerId: 'q-ifa-9o2',
    explanation: 'Primary survey: Danger (make safe), Response (are they conscious?), Airway (clear?), Breathing (normal?), Circulation (severe bleeding?).',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-10',
    topic: 'General',
    question: 'You come across an accident. Someone is trapped in a vehicle. What should you do?',
    options: [
      { id: 'q-ifa-10o1', text: 'Pull them out immediately' },
      { id: 'q-ifa-10o2', text: 'Call emergency services; keep them still and calm; do not move them unless in immediate danger (e.g. fire)' },
      { id: 'q-ifa-10o3', text: 'Leave them; wait for professionals' }
    ],
    answerId: 'q-ifa-10o2',
    explanation: 'Call emergency services. Keep the person still and calm. Do not move them unless there is immediate danger (e.g. fire).',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-11',
    topic: 'General',
    question: 'What should you do if a motorcyclist has come off their bike and is wearing a helmet?',
    options: [
      { id: 'q-ifa-11o1', text: 'Remove the helmet immediately' },
      { id: 'q-ifa-11o2', text: 'Do not remove the helmet unless they are not breathing or you are trained; support head and call for help' },
      { id: 'q-ifa-11o3', text: 'Leave the helmet on and move them' }
    ],
    answerId: 'q-ifa-11o2',
    explanation: 'Do not remove the helmet unless necessary (e.g. to open airway or perform CPR) or you are trained. Support the head and call for help.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-12',
    topic: 'General',
    question: 'What does "DRSABC" stand for in first aid?',
    options: [
      { id: 'q-ifa-12o1', text: 'Drive, Reverse, Stop, Accelerate, Brake, Clutch' },
      { id: 'q-ifa-12o2', text: 'Danger, Response, Send for help, Airway, Breathing, Circulation' },
      { id: 'q-ifa-12o3', text: 'Document, Report, Sign, Alert, Brief, Call' }
    ],
    answerId: 'q-ifa-12o2',
    explanation: 'DRSABC: Danger (make safe), Response (check consciousness), Send for help, Airway (open?), Breathing (normal?), Circulation (bleeding?).',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-13',
    topic: 'General',
    question: 'You have an accident and your vehicle is blocking the road. What should you do?',
    options: [
      { id: 'q-ifa-13o1', text: 'Leave it and go home' },
      { id: 'q-ifa-13o2', text: 'Warn other traffic (hazard lights, triangle if safe), move vehicle if possible and safe, call police if needed' },
      { id: 'q-ifa-13o3', text: 'Wait for someone else to move it' }
    ],
    answerId: 'q-ifa-13o2',
    explanation: 'Warn other traffic. If the vehicle can be moved safely (e.g. no serious injury), move it off the road. Report the accident if required.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-14',
    topic: 'General',
    question: 'What should you do if someone is in shock after an accident?',
    options: [
      { id: 'q-ifa-14o1', text: 'Give them food and drink' },
      { id: 'q-ifa-14o2', text: 'Keep them warm, lay them down if possible, raise legs slightly; call for help' },
      { id: 'q-ifa-14o3', text: 'Walk them around' }
    ],
    answerId: 'q-ifa-14o2',
    explanation: 'Keep them warm and calm. Lay them down and raise their legs slightly if possible. Call for emergency help. Do not give food or drink.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-15',
    topic: 'General',
    question: 'When should you move an injured person at an accident?',
    options: [
      { id: 'q-ifa-15o1', text: 'Always; get them to the side of the road' },
      { id: 'q-ifa-15o2', text: 'Only if they are in immediate danger (e.g. fire, traffic) and it is safe to do so' },
      { id: 'q-ifa-15o3', text: 'Never' }
    ],
    answerId: 'q-ifa-15o2',
    explanation: 'Move an injured person only if they are in immediate danger (e.g. fire, vehicle at risk of collision) and you can do so without causing further harm.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-16',
    topic: 'General',
    question: 'What should you do if you hit a dog or other animal?',
    options: [
      { id: 'q-ifa-16o1', text: 'Drive away quickly' },
      { id: 'q-ifa-16o2', text: 'Stop if safe; check on the animal; report to police or owner if required' },
      { id: 'q-ifa-16o3', text: 'Nothing; animals are not your responsibility' }
    ],
    answerId: 'q-ifa-16o2',
    explanation: 'Stop if safe to do so. Check on the animal. You may need to report to the police or try to find the owner.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-17',
    topic: 'General',
    question: 'What is the correct order of actions at an accident scene?',
    options: [
      { id: 'q-ifa-17o1', text: 'Give first aid, then make safe, then call for help' },
      { id: 'q-ifa-17o2', text: 'Make the scene safe, call for help, then give first aid if trained' },
      { id: 'q-ifa-17o3', text: 'Call for help only; do nothing else' }
    ],
    answerId: 'q-ifa-17o2',
    explanation: 'First make the scene safe (for you and others). Then call emergency services. Then give first aid if you are trained and it is safe.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-18',
    topic: 'General',
    question: 'You are first at the scene. There are several injured people. What should you do?',
    options: [
      { id: 'q-ifa-18o1', text: 'Treat the first person you see' },
      { id: 'q-ifa-18o2', text: 'Call emergency services with clear details; then help those with life-threatening injuries first if trained' },
      { id: 'q-ifa-18o3', text: 'Wait for the ambulance before doing anything' }
    ],
    answerId: 'q-ifa-18o2',
    explanation: 'Call emergency services first and give a clear picture of the scene. Then prioritise those with life-threatening injuries if you are trained.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-19',
    topic: 'General',
    question: 'What should you do if a casualty is not breathing but has a pulse?',
    options: [
      { id: 'q-ifa-19o1', text: 'Start CPR immediately' },
      { id: 'q-ifa-19o2', text: 'Open the airway and give rescue breaths if trained; call for help' },
      { id: 'q-ifa-19o3', text: 'Do nothing; wait for ambulance' }
    ],
    answerId: 'q-ifa-19o2',
    explanation: 'If they have a pulse but are not breathing, open the airway and give rescue breaths if you are trained. Call for help. If no pulse, start CPR.',
    subject: 'Incident & First Aid'
  },
  {
    id: 'q-ifa-20',
    topic: 'General',
    question: 'After an accident, why should you not admit fault at the scene?',
    options: [
      { id: 'q-ifa-20o1', text: 'Because it is illegal' },
      { id: 'q-ifa-20o2', text: 'Fault is for insurers and possibly courts to determine; stick to facts and exchange details' },
      { id: 'q-ifa-20o3', text: 'You should always admit fault' }
    ],
    answerId: 'q-ifa-20o2',
    explanation: 'Do not admit fault at the scene. Exchange details and report facts. Fault is determined by insurers and, if needed, the courts.',
    subject: 'Incident & First Aid'
  },
];
